import {InstitutionUnit} from "./Institution-unit";

export class Institution {
  public id: string;
  public units: InstitutionUnit[];
  public name: string;
  public url: string;
  public shortName: string;
}
